import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { CustomInputComponent } from '@/components/custom-input/custom-input.component';
import { CustomModalComponent } from '@/components/custom-modal/custom-modal.component';
import { LoadingComponent } from '@/components/loading/loading.component';
import { Utils } from '@/utils/utils';
import { Component, Input, Output, EventEmitter, OnInit, signal } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-iban-form',
  imports: [
    CustomModalComponent,
    ReactiveFormsModule,
    CustomInputComponent,
    LoadingComponent,
  ],
  templateUrl: './iban-form.component.html',
  styleUrl: './iban-form.component.scss',
})
export class IbanFormComponent implements OnInit {
  @Input() currentIbans: { label: string; iban: string; is_primary: boolean }[] = [];
  @Output() closeFunction = new EventEmitter<any>();
  @Output() acceptFunction = new EventEmitter<any>();

  public loading = signal(false);
  public saving = signal(false);
  public saveForm: FormGroup = new FormGroup({ ibans: new FormArray([]) });

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.currentIbans.forEach(item => this.addIban(item));
    if (this.ibans.length === 0) {
      this.addIban();
    }
  }

  get ibans(): FormArray {
    return this.saveForm.get('ibans') as FormArray;
  }

  addIban(item?: { label: string; iban: string; is_primary: boolean }) {
    this.ibans.push(new FormGroup({
      label: new FormControl(item?.label ?? '', [Validators.required]),
      iban: new FormControl(item?.iban ?? '', [Validators.required]),
      is_primary: new FormControl(item?.is_primary ?? this.ibans.length === 0),
    }));
  }

  removeIban(index: number) {
    const wasPrimary = this.ibans.at(index).get('is_primary')?.value;
    this.ibans.removeAt(index);
    if (wasPrimary && this.ibans.length > 0) {
      this.ibans.at(0).get('is_primary')?.setValue(true);
    }
  }

  setPrimary(index: number) {
    this.ibans.controls.forEach((ctrl, i) => {
      ctrl.get('is_primary')?.setValue(i === index);
    });
  }

  saveEntity() {
    if (this.saveForm.valid) {
      this.saving.set(true);
      this.apiService.save(Urls.urls.companyIban, { iban: this.ibans.value }, 0).subscribe({
        next: (response: any) => {
          Utils.notification.success('IBANs actualizados');
          this.acceptFunction.emit(response);
          this.closeFormFunction();
        },
        error: (error: any) => {
          Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al guardar los IBANs');
          this.saving.set(false);
        },
        complete: () => {
          this.saving.set(false);
        }
      });
    } else {
      Utils.notification.alert('Debe completar todos los campos obligatorios');
    }
  }

  acceptFormFunction() { this.saveEntity(); }
  closeFormFunction() { this.closeFunction.emit(); }
}
